(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

  // Preserve Horizon's jump-to-product behaviour.
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* Bath2U: click-to-load collection products, without auto loading on scroll.
     Native pagination stays available as a fallback when JavaScript is off. */
  if (!window.bath2uShowMoreInitialized) {
    window.bath2uShowMoreInitialized = true;

    const initializeShowMore = () => {
      document.querySelectorAll('results-list[data-bath2u-loading="button"]').forEach((results) => {
        const controls = results.querySelector('.bath2u-show-more');
        if (!controls) return;

        // Place the button directly after the product grid, rather than in the filter column.
        const gridWrapper = results.querySelector('#ResultsList > div');
        if (gridWrapper && controls.parentElement !== gridWrapper) {
          gridWrapper.appendChild(controls);
        }
        results.classList.add('bath2u-show-more-ready');
        controls.hidden = false;
      });
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest?.('.bath2u-show-more__button');
      if (!button || button.disabled) return;

      const results = button.closest('results-list');
      const controls = button.closest('.bath2u-show-more');
      const grid = results?.querySelector('#ResultsList .product-grid');
      const errorMessage = controls?.querySelector('.bath2u-show-more__error');
      if (!results || !grid || !controls) return;

      const nextUrl = button.dataset.nextUrl;
      if (!nextUrl) return;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading products…';
      button.setAttribute('aria-busy', 'true');
      if (errorMessage) errorMessage.hidden = true;

      try {
        const requestedUrl = new URL(nextUrl, window.location.origin);
        if (requestedUrl.origin !== window.location.origin) throw new Error('Invalid pagination URL');

        // Shopify Section Rendering API: fetch just this collection section.
        const sectionId = results.getAttribute('section-id');
        const sectionUrl = new URL(requestedUrl);
        sectionUrl.searchParams.set('section_id', sectionId);
        let response = await fetch(sectionUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        let markup = await response.text();
        let parsed = new DOMParser().parseFromString(markup, 'text/html');
        let nextResults = Array.from(parsed.querySelectorAll('results-list')).find(
          (element) => element.getAttribute('section-id') === sectionId
        );

        // Compatibility fallback for themes that don't return section-only markup.
        if (!nextResults) {
          response = await fetch(requestedUrl.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          markup = await response.text();
          parsed = new DOMParser().parseFromString(markup, 'text/html');
          nextResults = Array.from(parsed.querySelectorAll('results-list')).find(
            (element) => element.getAttribute('section-id') === sectionId
          );
        }
        if (!nextResults) throw new Error('Collection section not found');

        const nextGrid = nextResults.querySelector('#ResultsList .product-grid');
        if (!nextGrid) throw new Error('Product grid not found');
        const nextCards = [...nextGrid.querySelectorAll(':scope > .product-grid__item')];
        if (!nextCards.length) throw new Error('No additional products returned');

        // Don't append stale results if filters/sorting replaced the section while loading.
        if (!results.isConnected || !grid.isConnected || !button.isConnected) return;

        const existingIds = new Set(
          [...grid.querySelectorAll(':scope > .product-grid__item')].map((card) => card.dataset.productId)
        );
        const fragment = document.createDocumentFragment();
        let added = 0;
        nextCards.forEach((card) => {
          if (existingIds.has(card.dataset.productId)) return;
          existingIds.add(card.dataset.productId);
          fragment.appendChild(card);
          added++;
        });
        if (!added) throw new Error('Products already loaded');
        grid.appendChild(fragment);

        const nextControls = nextResults.querySelector('.bath2u-show-more__button');
        if (nextControls?.dataset.nextUrl) {
          button.dataset.nextUrl = nextControls.dataset.nextUrl;
        } else {
          controls.remove(); // Reached the last page.
        }
      } catch (error) {
        console.error('Bath2U Show more:', error);
        if (errorMessage) errorMessage.hidden = false;
        // Restore native pagination as another way to continue if AJAX fails.
        results.classList.remove('bath2u-show-more-ready');
      } finally {
        button.disabled = false;
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      }
    });

    /* Collection-only product-name search.
       Retrieve the collection's remaining pages via Shopify Section Rendering,
       so searches also find products not yet displayed by Show more.
       Never searches products in unrelated collections. */
    const searchInstances = new WeakMap();

    const initializeCollectionSearch = () => {
      document.querySelectorAll('results-list .bath2u-collection-search').forEach((searchBar) => {
        const results = searchBar.closest('results-list');
        const grid = results?.querySelector('#ResultsList .product-grid');
        const gridContainer = results?.querySelector('#ResultsList > div');
        if (!results || !grid || !gridContainer) return;

        // Put the search in Horizon's existing item-count / sort toolbar.
        // Match the width of the first three grid columns, including gaps.
        // Grid tracks exist even when this collection has fewer than 3 products.
        let sizingFrame = 0;
        const fitSearchToCards = () => {
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          const toolbar = results.querySelector('.facets--horizontal.facets-controls-wrapper');
          if (!desktop || !toolbar || searchBar.parentElement !== toolbar) {
            searchBar.style.removeProperty('--bath2u-search-cards-width');
            searchBar.style.removeProperty('--bath2u-search-offset');
            return;
          }

          const gridStyle = getComputedStyle(grid);
          const columnWidths = gridStyle.gridTemplateColumns
            .split(/\s+/)
            .map((value) => parseFloat(value))
            .filter((value) => Number.isFinite(value) && value > 0);
          const gap = parseFloat(gridStyle.columnGap) || 0;
          const columnsToSpan = Math.min(3, columnWidths.length);
          if (!columnsToSpan) return;

          const targetWidth = Math.round(
            columnWidths.slice(0, columnsToSpan).reduce((sum, width) => sum + width, 0)
            + gap * (columnsToSpan - 1)
          );
          if (targetWidth < 1) return;
          searchBar.style.setProperty('--bath2u-search-cards-width', `${targetWidth}px`);

          // Calculate against the offset already in use; otherwise repeated
          // resize / section callbacks would make the bar jump left and right.
          const priorOffset = parseFloat(searchBar.style.getPropertyValue('--bath2u-search-offset')) || 0;
          const measuredLeft = searchBar.getBoundingClientRect().left;
          const newOffset = Math.max(0, Math.round(priorOffset + grid.getBoundingClientRect().left - measuredLeft));
          searchBar.style.setProperty('--bath2u-search-offset', `${newOffset}px`);
        };
        const positionBar = () => {
          const toolbar = results.querySelector('.facets--horizontal.facets-controls-wrapper');
          const count = toolbar?.querySelector('.products-count-wrapper');
          if (window.matchMedia('(min-width: 750px)').matches && toolbar) {
            if (searchBar.parentElement !== toolbar) {
              if (count) toolbar.insertBefore(searchBar, count);
              else toolbar.appendChild(searchBar);
            }
          } else if (searchBar.parentElement !== gridContainer) {
            gridContainer.insertBefore(searchBar, gridContainer.firstChild);
          }
          searchBar.classList.add('bath2u-search-mounted');
          cancelAnimationFrame(sizingFrame);
          sizingFrame = requestAnimationFrame(fitSearchToCards);
        };
        positionBar();

        const existing = searchInstances.get(searchBar);
        if (existing) return;

        const input = searchBar.querySelector('.bath2u-collection-search__input');
        const clear = searchBar.querySelector('.bath2u-collection-search__clear');
        const status = results.querySelector('.bath2u-search-status');
        if (status && status.parentElement !== gridContainer) {
          gridContainer.insertBefore(status, grid);
        }
        const count = results.querySelector('.facets--horizontal .products-count-wrapper > span');
        if (!input) return;

        const state = {
          originalCards: null,
          originalCount: count?.textContent || '',
          allCards: new Map(),
          loading: null,
          currentQuery: '',
          timer: null,
        };
        searchInstances.set(searchBar, state);

        const normalize = (text) => (text || '').normalize('NFKC').toLocaleLowerCase().trim();
        const isCurrent = () => results.isConnected && grid.isConnected && searchBar.isConnected;
        const cardsFrom = (root) => [...root.querySelectorAll('#ResultsList .product-grid > .product-grid__item')];
        const originalPage = Number(searchBar.dataset.page || 1);
        const totalPages = Number(grid.dataset.lastPage || 1);
        const sectionId = results.getAttribute('section-id');

        const restore = () => {
          if (state.originalCards) {
            grid.replaceChildren(...state.originalCards);
          }
          state.currentQuery = '';
          results.classList.remove('bath2u-search-active', 'bath2u-search-fetching');
          if (status) {
            status.hidden = true;
            status.textContent = '';
          }
          if (count) count.textContent = state.originalCount;
          clear.hidden = true;
        };

        const paint = () => {
          if (!isCurrent()) return;
          const query = normalize(state.currentQuery);
          if (!query) { restore(); return; }

          const words = query.split(/\s+/).filter(Boolean);
          const matches = [...state.allCards.values()].filter((card) => {
            const title = normalize(card.dataset.productTitle);
            return words.every((word) => title.includes(word));
          });
          grid.replaceChildren(...matches);
          if (count) count.textContent = `${matches.length} ITEMS`;
          if (status) {
            status.hidden = matches.length !== 0;
            status.textContent = matches.length ? '' : 'No matching products in this collection.';
          }
          results.classList.remove('bath2u-search-fetching');
        };

        const readPage = async (page) => {
          const target = new URL(window.location.href);
          target.searchParams.set('page', String(page));
          target.searchParams.set('section_id', sectionId);
          let response = await fetch(target.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          let html = await response.text();
          let doc = new DOMParser().parseFromString(html, 'text/html');
          let pageResults = [...doc.querySelectorAll('results-list')].find(
            (el) => el.getAttribute('section-id') === sectionId
          );
          if (!pageResults) {
            target.searchParams.delete('section_id');
            response = await fetch(target.toString(), { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            html = await response.text();
            doc = new DOMParser().parseFromString(html, 'text/html');
            pageResults = [...doc.querySelectorAll('results-list')].find(
              (el) => el.getAttribute('section-id') === sectionId
            );
          }
          if (!pageResults) throw new Error('Collection results not found');
          return cardsFrom(pageResults);
        };

        const indexEveryPage = async () => {
          // Keep the visible cards as original nodes so Clear restores all
          // previously loaded products and their Show more state exactly.
          if (!state.originalCards) state.originalCards = cardsFrom(results);
          for (const card of state.originalCards) {
            state.allCards.set(card.dataset.productId, card);
          }

          const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => page !== originalPage);

          // Four parallel workers avoid slow, fully sequential page requests.
          let index = 0;
          const worker = async () => {
            while (index < pages.length) {
              const page = pages[index++];
              const pageCards = await readPage(page);
              if (!isCurrent()) return;
              for (const card of pageCards) {
                if (card.dataset.productId && !state.allCards.has(card.dataset.productId)) {
                  state.allCards.set(card.dataset.productId, card);
                }
              }
            }
          };
          await Promise.all(Array.from({ length: Math.min(4, pages.length) }, () => worker()));
          // Map insertion order depends on network; restore collection sorting
          // by the page number and card's original index in the page.
          state.allCards = new Map([...state.allCards].sort((a, b) => {
            const ca = a[1], cb = b[1];
            const pa = Number(ca.dataset.page || 1), pb = Number(cb.dataset.page || 1);
            if (pa !== pb) return pa - pb;
            const ia = Number((ca.className.match(/product-grid__item--(\d+)/) || [])[1] || 0);
            const ib = Number((cb.className.match(/product-grid__item--(\d+)/) || [])[1] || 0);
            return ia - ib;
          }));
        };

        const search = () => {
          state.currentQuery = input.value;
          const query = normalize(state.currentQuery);
          clear.hidden = !query;
          if (!query) { restore(); return; }
          if (!state.originalCards) state.originalCards = cardsFrom(results);
          results.classList.add('bath2u-search-active');

          if (state.loading === null) {
            results.classList.add('bath2u-search-fetching');
            if (status) {
              status.hidden = false;
              status.textContent = 'Searching all products in this collection…';
            }
            state.loading = indexEveryPage().then(() => {
              state.loading = Promise.resolve();
              if (normalize(state.currentQuery)) paint();
            }).catch((error) => {
              console.warn('Bath2U collection search:', error);
              state.loading = null;
              // Keep already fetched results, but don't claim there are no
              // matches when the remaining pages could not be loaded.
              if (isCurrent() && normalize(state.currentQuery)) {
                results.classList.remove('bath2u-search-fetching');
                if (status) {
                  status.hidden = false;
                  status.textContent = 'Could not search all products. Please try again.';
                }
              }
            });
          } else if (!results.classList.contains('bath2u-search-fetching')) {
            paint();
          }
        };

        input.addEventListener('input', () => {
          clearTimeout(state.timer);
          state.timer = setTimeout(search, 230);
        });
        input.addEventListener('search', () => {
          clearTimeout(state.timer);
          search();
        });
        clear.addEventListener('click', () => {
          clearTimeout(state.timer);
          input.value = '';
          restore();
          input.focus();
        });
        window.addEventListener('resize', positionBar, { passive: true });
      });
    };

    const initializeCollectionControls = () => {
      initializeShowMore();
      initializeCollectionSearch();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCollectionControls, { once: true });
    } else {
      initializeCollectionControls();
    }
    document.addEventListener('shopify:section:load', initializeCollectionControls);

    // Horizon refreshes the results markup when filters or sorting change.
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        initializeCollectionControls();
      });
    });
    const startObserver = () => observer.observe(document.body, { childList: true, subtree: true });
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
